/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Scheme Animation

Tutorials:

1. How to correctly export an SVG from Illustrator: https://www.youtube.com/watch?v=bWcweY66DL8
2. Getting started with Greensock: https://greensock.com/get-started-js

*/

$(function(){


    // SCHRITT 1

    // Stromzähler

    TweenMax.to('#stromzaehler-zeiger', 0.8, {
        rotation:65,
        transformOrigin: '72% 84%',
        repeat: -1,
        ease: Back.easeInOut.config(5),
        yoyo: true
        }
    );


    // Wärmezähler

    TweenMax.to('#waermezaehler-zeiger', 3, {
        rotation:67,
        transformOrigin: '72% 84%',
        repeat: -1,
        delay: 0.2,
        ease: Back.easeInOut.config(2),
        yoyo: true
        }
    );


    // Wasseruhr

    TweenMax.to('#wasseruhr-zeiger', 1.5, {
        rotation:80,
        transformOrigin: '72% 84%',
        repeat: -1,
        delay: 0.4,
        ease: Back.easeInOut.config(4),
        yoyo: true
        }
    );


    // Gaszähler

    TweenMax.to('#gaszaehler-zeiger', 1.2, {
        rotation:70,
        transformOrigin: '72% 84%',
        repeat: -1,
        delay: 0.1,
        ease: Back.easeInOut.config(3),
        yoyo: true
        }
    );



    // SCHRITT 2

    // Wärmepumpe & Elektroboiler

    TweenMax.from('#anzeige', 1, {
        scaleY: 0.1,
        transformOrigin: 'bottom',
        repeat: -1,
        }
    );

    TweenMax.to('#anzeige', 1, {
        scaleY: 1,
        transformOrigin: 'bottom',
        repeat: -1,
        ease: Back.easeOut.config(2),
        yoyo: true
        }
    );


    // Batteriespeicher

    var tl = new TimelineLite({onComplete:function() {
        this.restart()}
    });

    tl.from('#balken-1', 0.4, {opacity: 0})
    .from('#balken-2', 0.4, {opacity: 0}, "-=0.2")
    .from('#balken-3', 0.4, {opacity: 0}, "-=0.2")
    .from('#balken-4', 0.4, {opacity: 0}, "-=0.2");

    tl.to('#balken-1, #balken-2, #balken-3, #balken-4', 0.2, {opacity: 0})


    //Elektromobilität

    var tl = new TimelineLite({onComplete:function() {
        this.restart()}
    });

    tl.from('#batterie-linie-1', 0.4, {opacity: 0})
    .from('#batterie-linie-2', 0.4, {opacity: 0})
    .from('#batterie-linie-3', 0.4, {opacity: 0})

    tl.to('#batterie-linie-1, #batterie-linie-2, #batterie-linie-3', 0.2, {opacity: 0})


    // Haushaltsgeräte

    TweenMax.to('#waschmaschiene-innen', 8, {
        rotation: 2880,
        repeat: -1,
        transformOrigin: 'center',
        ease: Sine.easeInOut,
        delay: 2
        }
    );



    // SCHRITT 3

    // Auswertung

    var tl = new TimelineLite({onComplete:function() {
        this.restart()}
    });

    tl.from('#auswertung-welle-1-2', 0.4, {opacity: 0})
    .from('#auswertung-welle-1-1', 0.4, {opacity: 0}, "-=0.15")

    tl.to('#auswertung-welle-1-2', 0.4, {opacity: 0})
    .to('#auswertung-welle-1-1', 0.4, {opacity: 0}, "-=0.15")


    var tl = new TimelineLite({onComplete:function() {
        this.restart()}
    });

    tl.from('#auswertung-welle-2-1', 0.4, {opacity: 0})
    .from('#auswertung-welle-2-2', 0.4, {opacity: 0}, "-=0.15")

    tl.to('#auswertung-welle-2-1', 0.4, {opacity: 0})
    .to('#auswertung-welle-2-2', 0.4, {opacity: 0}, "-=0.15")


    // Cloud Data

    var tl = new TimelineLite({onComplete:function() {
        this.restart()}
    });

    tl.from('#welle-1-1', 0.4, {opacity: 0})
    .from('#welle-1-2', 0.4, {opacity: 0}, "-=0.2")
    .from('#welle-1-3', 0.4, {opacity: 0}, "-=0.2")

    tl.to('#welle-1-1', 0.4, {opacity: 0})
    .to('#welle-1-2', 0.4, {opacity: 0}, "-=0.15")
    .to('#welle-1-3', 0.4, {opacity: 0}, "-=0.15")


    var tl = new TimelineLite({onComplete:function() {
        this.restart()}
    });

    tl.from('#welle-2-1', 0.4, {opacity: 0})
    .from('#welle-2-2', 0.4, {opacity: 0}, "-=0.2")
    .from('#welle-2-3', 0.4, {opacity: 0}, "-=0.2")

    tl.to('#welle-2-1', 0.4, {opacity: 0})
    .to('#welle-2-2', 0.4, {opacity: 0}, "-=0.15")
    .to('#welle-2-3', 0.4, {opacity: 0}, "-=0.15")


    // Energierechnung

    TweenMax.to('#papier-gedruckt', 1, {
        y: 6,
        transformOrigin: 'top',
        repeat: -1,
        ease: Sine.easeInOut,
        yoyo: true
        }
    );

    TweenMax.to('#papier-oben', 1, {
        y: 6,
        transformOrigin: 'top',
        repeat: -1,
        ease: Sine.easeInOut,
        yoyo: true
        }
    );

    TweenMax.from('#fade-out', 1, {
        opacity: 0,
        transformOrigin: 'top',
        repeat: -1,
        ease: Sine.easeInOut,
        }
    );

    TweenMax.from('#drucker-kreis', 0.5, {
        repeat: -1,
        opacity: 0,
        ease: Back.easeOut.config(1),
        yoyo: true
        }
    );




    // Photovoltaik Anlage

    var tl = new TimelineLite({onComplete:function() {
        this.restart()}
    });


    tl.from('#sonnenstrahl-1', 0.4, {x: -3, y: 3})
    .from('#sonnenstrahl-2', 0.4, {x: -3}, "-=0.3")
    .from('#sonnenstrahl-3', 0.4, {x: -3, y: -3}, "-=0.3")
    .from('#sonnenstrahl-4', 0.4, {y: -3}, "-=0.3")
    .from('#sonnenstrahl-5', 0.4, {x: 3, y: -3}, "-=0.3")
    .from('#sonnenstrahl-6', 0.4 , {x: 3}, "-=0.3")

    tl.to('#sonnenstrahl-1', 0.4, {x: -3, y: 3})
    .to('#sonnenstrahl-2', 0.4, {x: -3}, "-=0.3")
    .to('#sonnenstrahl-3', 0.4, {x: -3, y: -3}, "-=0.3")
    .to('#sonnenstrahl-4', 0.4, {y: -3}, "-=0.3")
    .to('#sonnenstrahl-5', 0.4, {x: 3, y: -3}, "-=0.3")
    .to('#sonnenstrahl-6', 0.4 , {x: 3}, "-=0.3")

    // Punkt

    TweenMax.from('#punkt', 0.65, {
        repeat: -1,
        opacity: 0,
        ease: Back.easeOut.config(1),
        yoyo: true
        }
    );

});



// WEBPACK FOOTER //
// ./static/js/modules/scheme-animation.js